import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteV2PublishAllowanceQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type WebsiteV2PublishAllowanceQuery = {
  __typename?: 'Query';
  carbonWebsiteAiAllowance:
    | { __typename?: 'CarbonWebsiteAiEnforcedAllowance'; eventId: string; kind: string; publishRequiresPurchase?: boolean | null }
    | { __typename?: 'CarbonWebsiteAiObservedAllowance'; eventId: string; kind: string; publishRequiresPurchase?: boolean | null };
};

export type WebsiteV2PublishSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
  eventId: Types.Scalars['ID'];
}>;

export type WebsiteV2PublishSiteMutation = {
  __typename?: 'Mutation';
  carbonWebsitePublishSite: { __typename?: 'CarbonWebsiteSite'; id: string; published: boolean; publishedAt?: any | null };
};

export type WebsiteV2UnpublishSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['String'];
  eventId: Types.Scalars['ID'];
}>;

export type WebsiteV2UnpublishSiteMutation = {
  __typename?: 'Mutation';
  carbonWebsiteUnpublishSite: { __typename?: 'CarbonWebsiteSite'; id: string; published: boolean; publishedAt?: any | null };
};

export type WebsiteV2EventWebsiteStateQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type WebsiteV2EventWebsiteStateQuery = { __typename?: 'Query'; eventById?: { __typename?: 'Event'; id: string; websiteState: Types.EventWebsiteState } | null };

export type WebsiteV2SyncEventWebsiteStateMutationVariables = Types.Exact<{
  payload: Types.EventSetWebsiteStatePayload;
}>;

export type WebsiteV2SyncEventWebsiteStateMutation = { __typename?: 'Mutation'; eventSetWebsiteState: { __typename?: 'Event'; id: string; websiteState: Types.EventWebsiteState } };

export const WebsiteV2PublishAllowanceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2PublishAllowance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteAiAllowance' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishRequiresPurchase' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2PublishAllowanceQuery__
 *
 * To run a query within a React component, call `useWebsiteV2PublishAllowanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2PublishAllowanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2PublishAllowanceQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWebsiteV2PublishAllowanceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2PublishAllowanceQuery, WebsiteV2PublishAllowanceQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2PublishAllowanceQuery, WebsiteV2PublishAllowanceQueryVariables>(WebsiteV2PublishAllowanceDocument, baseOptions);
}
export function useWebsiteV2PublishAllowanceLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2PublishAllowanceQuery, WebsiteV2PublishAllowanceQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2PublishAllowanceQuery, WebsiteV2PublishAllowanceQueryVariables>(WebsiteV2PublishAllowanceDocument, baseOptions);
}
export type WebsiteV2PublishAllowanceQueryHookResult = ReturnType<typeof useWebsiteV2PublishAllowanceQuery>;
export type WebsiteV2PublishAllowanceLazyQueryHookResult = ReturnType<typeof useWebsiteV2PublishAllowanceLazyQuery>;
export type WebsiteV2PublishAllowanceQueryResult = Apollo.QueryResult<WebsiteV2PublishAllowanceQuery, WebsiteV2PublishAllowanceQueryVariables>;
export const WebsiteV2PublishSiteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2PublishSite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsitePublishSite' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'siteId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2PublishSiteMutationFn = Apollo.MutationFunction<WebsiteV2PublishSiteMutation, WebsiteV2PublishSiteMutationVariables>;

/**
 * __useWebsiteV2PublishSiteMutation__
 *
 * To run a mutation, you first call `useWebsiteV2PublishSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2PublishSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2PublishSiteMutation, { data, loading, error }] = useWebsiteV2PublishSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWebsiteV2PublishSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2PublishSiteMutation, WebsiteV2PublishSiteMutationVariables>) {
  return ApolloReactHooks.useMutation<WebsiteV2PublishSiteMutation, WebsiteV2PublishSiteMutationVariables>(WebsiteV2PublishSiteDocument, baseOptions);
}
export type WebsiteV2PublishSiteMutationHookResult = ReturnType<typeof useWebsiteV2PublishSiteMutation>;
export type WebsiteV2PublishSiteMutationResult = Apollo.MutationResult<WebsiteV2PublishSiteMutation>;
export type WebsiteV2PublishSiteMutationOptions = Apollo.BaseMutationOptions<WebsiteV2PublishSiteMutation, WebsiteV2PublishSiteMutationVariables>;
export const WebsiteV2UnpublishSiteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2UnpublishSite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'carbonWebsiteUnpublishSite' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'siteId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'published' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2UnpublishSiteMutationFn = Apollo.MutationFunction<WebsiteV2UnpublishSiteMutation, WebsiteV2UnpublishSiteMutationVariables>;

/**
 * __useWebsiteV2UnpublishSiteMutation__
 *
 * To run a mutation, you first call `useWebsiteV2UnpublishSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2UnpublishSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2UnpublishSiteMutation, { data, loading, error }] = useWebsiteV2UnpublishSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWebsiteV2UnpublishSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2UnpublishSiteMutation, WebsiteV2UnpublishSiteMutationVariables>) {
  return ApolloReactHooks.useMutation<WebsiteV2UnpublishSiteMutation, WebsiteV2UnpublishSiteMutationVariables>(WebsiteV2UnpublishSiteDocument, baseOptions);
}
export type WebsiteV2UnpublishSiteMutationHookResult = ReturnType<typeof useWebsiteV2UnpublishSiteMutation>;
export type WebsiteV2UnpublishSiteMutationResult = Apollo.MutationResult<WebsiteV2UnpublishSiteMutation>;
export type WebsiteV2UnpublishSiteMutationOptions = Apollo.BaseMutationOptions<WebsiteV2UnpublishSiteMutation, WebsiteV2UnpublishSiteMutationVariables>;
export const WebsiteV2EventWebsiteStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteV2EventWebsiteState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteState' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteV2EventWebsiteStateQuery__
 *
 * To run a query within a React component, call `useWebsiteV2EventWebsiteStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2EventWebsiteStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteV2EventWebsiteStateQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWebsiteV2EventWebsiteStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteV2EventWebsiteStateQuery, WebsiteV2EventWebsiteStateQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteV2EventWebsiteStateQuery, WebsiteV2EventWebsiteStateQueryVariables>(WebsiteV2EventWebsiteStateDocument, baseOptions);
}
export function useWebsiteV2EventWebsiteStateLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteV2EventWebsiteStateQuery, WebsiteV2EventWebsiteStateQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteV2EventWebsiteStateQuery, WebsiteV2EventWebsiteStateQueryVariables>(WebsiteV2EventWebsiteStateDocument, baseOptions);
}
export type WebsiteV2EventWebsiteStateQueryHookResult = ReturnType<typeof useWebsiteV2EventWebsiteStateQuery>;
export type WebsiteV2EventWebsiteStateLazyQueryHookResult = ReturnType<typeof useWebsiteV2EventWebsiteStateLazyQuery>;
export type WebsiteV2EventWebsiteStateQueryResult = Apollo.QueryResult<WebsiteV2EventWebsiteStateQuery, WebsiteV2EventWebsiteStateQueryVariables>;
export const WebsiteV2SyncEventWebsiteStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'WebsiteV2SyncEventWebsiteState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSetWebsiteStatePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventSetWebsiteState' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteState' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WebsiteV2SyncEventWebsiteStateMutationFn = Apollo.MutationFunction<WebsiteV2SyncEventWebsiteStateMutation, WebsiteV2SyncEventWebsiteStateMutationVariables>;

/**
 * __useWebsiteV2SyncEventWebsiteStateMutation__
 *
 * To run a mutation, you first call `useWebsiteV2SyncEventWebsiteStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWebsiteV2SyncEventWebsiteStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [websiteV2SyncEventWebsiteStateMutation, { data, loading, error }] = useWebsiteV2SyncEventWebsiteStateMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteV2SyncEventWebsiteStateMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<WebsiteV2SyncEventWebsiteStateMutation, WebsiteV2SyncEventWebsiteStateMutationVariables>,
) {
  return ApolloReactHooks.useMutation<WebsiteV2SyncEventWebsiteStateMutation, WebsiteV2SyncEventWebsiteStateMutationVariables>(WebsiteV2SyncEventWebsiteStateDocument, baseOptions);
}
export type WebsiteV2SyncEventWebsiteStateMutationHookResult = ReturnType<typeof useWebsiteV2SyncEventWebsiteStateMutation>;
export type WebsiteV2SyncEventWebsiteStateMutationResult = Apollo.MutationResult<WebsiteV2SyncEventWebsiteStateMutation>;
export type WebsiteV2SyncEventWebsiteStateMutationOptions = Apollo.BaseMutationOptions<WebsiteV2SyncEventWebsiteStateMutation, WebsiteV2SyncEventWebsiteStateMutationVariables>;
